import { render } from "./specs-enclosure-screen.vue?vue&type=template&id=b5751eee&scoped=true"
import script from "./specs-enclosure-screen.vue?vue&type=script&lang=js"
export * from "./specs-enclosure-screen.vue?vue&type=script&lang=js"

import "./specs-enclosure-screen.vue?vue&type=style&index=0&id=b5751eee&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5751eee"]])

export default __exports__